import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";

function RmsLeaderboard() {
    const [cookies] = useCookies(['user']);
    const user_id = cookies.user_id;
    const token = cookies.token;
    const items = [];
    const items2 = [];
    // const prevScrollY = useRef(0);
    let history = useHistory();
    useEffect(() => {
        localStorage.setItem("loader", "free");
        getLeaderboardData();
    }, []);
    const [leaderData, setLeaderData] = useState({ "status": "failuer", "self": { "dist_user_id": "", "rank": "NA", "points": 0, "name": "", "city": "", "profile_pic": "" }, "leaders": [] });
    const [error1, setError] = useState(false);
    const [seasonAward, setSeasonAward] = useState('');
    const [switchType, setSwitchType] = useState({ "bg_col_1": "white", "color_1": "#454545", "bg_col_2": "#454545", "color_2": "white" });
    const [leaders, setLeaders] = useState([]);
    const [finalLeaders, setFinalLeaders] = useState([]);
    const [startRank, setStartRank] = useState(1);
    const [endRank, setEndRank] = useState(10);

    const prevScrollY = useRef(0);
    const [goingUp, setGoingUp] = useState(false);
    const onScroll = (e) => {
        const currentScrollY = e.target.scrollTop;
        if (prevScrollY.current < currentScrollY && goingUp) {
            setGoingUp(false);
        }
        if (prevScrollY.current > currentScrollY && !goingUp) {
            setGoingUp(true);
        }
        prevScrollY.current = currentScrollY;
        // console.log(Math.ceil(window.innerHeight +currentScrollY - 100));
        // console.log(e.target.scrollHeight);

        if (Math.ceil(window.innerHeight + currentScrollY) > e.target.scrollHeight) {
            // Do load more content here!
            console.log("bottom");
            loadMore("down")
        }
        if (currentScrollY === 100) {
            console.log("top");
            loadMore("up")
        }
    };

    async function loadMore(params) {
        if (localStorage.getItem("loader") === "free") {
            localStorage.setItem("loader", "loading");
            let s = endRank + 1;
            let e = endRank + 100;
            let type = localStorage.getItem("lType");
            let body = { dist_user_id: user_id, start_rank: s, end_rank: e, type: type };
            if (localStorage.getItem("lFetch") !== localStorage.getItem("lType")) {
                body = { dist_user_id: user_id, type: type };
            }
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
                body: JSON.stringify(body),
            };
            const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
            const data = await response.json();
            if (data.status !== "success") {
                setError(true);
            }
            for (const [index, value] of data.leaders.entries()) {
                let pp = '';
                if (value.profile_pic === 'NA' || value.profile_pic === '') {
                    pp = require("./../images/defaultProfile.png").default;
                } else {
                    pp = value.profile_pic;
                }
                let row = await getHtml(value);
                items.push(row);
            }
            // setLeaders(leaders.concat(items));
            if (localStorage.getItem("lFetch") === localStorage.getItem("lType")) {
                await addMilestoneCards(leaders.concat(items));
            } else {
                setLeaders(items);
                await addMilestoneCards(items);
            }

            // console.log(leaders);
            setEndRank(data.end_rank);
            localStorage.setItem("lFetch", type);
            localStorage.setItem("loader", "free");
        }
    }
    const getLeaderboardData = async () => {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token, 'userId': user_id },
            body: JSON.stringify({ dist_user_id: user_id, type: "all", start_rank: 1, end_rank: 100 }),

        };
        localStorage.setItem("milestone", JSON.stringify({ "l1": "", "l5": "", "l10": "", "l25": "" }));
        const response = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
        const data = await response.json();
        if (data.status !== "success") {
            setError(true);
        }
        localStorage.setItem("lFetch", "all");
        localStorage.setItem("lType", "all");
        for (const [index, value] of data.leaders.entries()) {
            let pp = '';
            if (value.profile_pic === 'NA' || value.profile_pic === '') {
                pp = require("./../images/defaultProfile.png").default;
            } else {
                pp = value.profile_pic;
            }
            let row = await getHtml(value, data.self.dist_user_id);
            localStorage.setItem("selfPoints", data.self.points);
            let currentPoints = value.points;
            items.push(row);
        }
        // console.log(items);
        // delete items[49];
        // setLeaders(items);
        await addMilestoneCards(items);
        setSeasonAward(data.season_data.banner);
        setLeaderData(data);
        setStartRank(data.start_rank);
        setEndRank(data.end_rank);
    };

    async function addMilestoneCards(lead) {
        // setLeaders(lead);
        // console.log(lead.length);
        let i = 0;
        let l1 = '';
        let l5 = '';
        let l10 = '';
        let l25 = '';
        let selfPoints = localStorage.getItem("selfPoints");
        selfPoints = selfPoints.replaceAll(',', '');
        for (; i < lead.length; i++) {
            let key = lead[i].key;
            if (key === "1l" || key === "5l" || key === "10l" || key === "25l") {
                delete leaders[i];
                continue;
            }

            key = key.split('-');
            // console.log(key[0]);
            // console.log(key[1]);
            let points = key[1];
            points = points.replaceAll(',', '');
            if (l25 === '' && points < 2500000) {
                l25 = 'done';
                let img = require("./../images/10-gm-unachieved.png").default;
                if (selfPoints >= 2500000) {
                    img = require("./../images/10-gm-achieved.svg").default;
                }
                items2.push(
                    <div key="25l" className="row row-mrg-override">
                        <div className="w-100 mrg-10 top-rank">
                            <img src={img} alt="back" className="img-fluid" />
                        </div>
                    </div>
                );
                // setLeaders(items.concat(leaders));
            }
            if (l10 === '' && points < 1000000) {
                l10 = 'done';
                let img = require("./../images/5-gm-unachieved.svg").default;
                if (selfPoints >= 1000000) {
                    img = require("./../images/5-gm-achieved.svg").default;
                }
                items2.push(
                    <div key="10l" className="row row-mrg-override">
                        <div className="w-100 mrg-10 top-rank">
                            <img src={img} alt="back" className="img-fluid" />
                        </div>
                    </div>
                );
                // setLeaders(items.concat(leaders));
            }
            if (l5 === '' && points < 500000) {
                l5 = 'done';
                let img = require("./../images/10k-unachieved.svg").default;
                if (selfPoints > 500000) {
                    img = require("./../images/10k-achieved.svg").default;
                }
                items2.push(
                    <div key="5l" className="row row-mrg-override">
                        <div className="w-100 mrg-10 top-rank">
                            <img src={img} alt="back" className="img-fluid" />
                        </div>
                    </div>
                );
                // setLeaders(items.concat(leaders));
            }
            if (l1 === '' && points < 100000) {
                l1 = 'done';
                let img = require("./../images/3k-unachieved.svg").default;
                if (selfPoints > 100000) {
                    img = require("./../images/3k-achieved.svg").default;
                }
                items2.push(
                    <div key="1l" className="row row-mrg-override">
                        <div className="w-100 mrg-10 top-rank">
                            <img src={img} alt="back" className="img-fluid" />
                        </div>
                    </div>
                );
                // setLeaders(items.concat(leaders));
            }
            items2.push(lead[i]);
        }
        setLeaders(items2);
    }
	async function getHtml(value, distUserId='', selfPoints=''){
		let html = '';
		let a = JSON.parse(localStorage.getItem("milestone"));
		let num_font_sz = "";
		// console.log(a);
		// localStorage.setItem("milestone",JSON.stringify((a)));
		// console.log(value.city);
		// console.log(value.name);
		if(value.rank === "1"){
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override position-relative">
				<div className="w-100 mrg-10 top-rank">
					<img src={require("./../images/1st.svg").default} alt="back" className="img-fluid" />
				</div>
				<div className="w-100 pad-l-15 top-rank relative-data">
					<div className="w-50 margin-data col-bluver">
						<div className="top-title noWrap" title={value.name}>{value.name}</div>
						<div className="top-shop noWrap" title={value.company_name}>{value.company_name} | {value.shop_state}</div>
						<div className="top-points">
							<span><img src={require("./../images/pay1-points-img.svg").default} alt="point-icon" className="img-fluid"/></span>
							<span className="top-points-val">{value.points}</span>
						</div>
					</div>
				</div>
			</div>;
		} else if(value.rank === "2"){
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override position-relative">
				<div className="w-100 mrg-10 top-rank">
					<img src={require("./../images/2nd.svg").default} alt="back" className="img-fluid" />
				</div>
				<div className="w-100 pad-l-15 top-rank relative-data">
					<div className="w-50 margin-data col-bluver">
						<div className="top-title noWrap" title={value.name}>{value.name}</div>
						<div className="top-shop noWrap" title={value.company_name}>{value.company_name} | {value.shop_state}</div>
						<div className="top-points">
							<span><img src={require("./../images/pay1-points-img.svg").default} alt="point-icon" className="img-fluid"/></span>
							<span className="top-points-val">{value.points}</span>
						</div>
					</div>
				</div>
			</div>;

		} else if(value.rank === "3"){
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override position-relative">
				<div className="w-100 mrg-10 top-rank">
					<img src={require("./../images/3rd.svg").default} alt="back" className="img-fluid" />
				</div>
				<div className="w-100 pad-l-15 top-rank relative-data">
					<div className="w-50 margin-data col-wht">
						<div className="top-title noWrap" title={value.name}>{value.name}</div>
						<div className="top-shop noWrap" title={value.company_name}>{value.company_name} | {value.shop_state}</div>
						<div className="top-points">
							<span><img src={require("./../images/pay-point-icon.svg").default} alt="point-icon" className="img-fluid"/></span>
							<span className="top-points-val">{value.points}</span>
						</div>
					</div>
				</div>
			</div>;

		} else if(value.dist_user_id == distUserId ){
			num_font_sz = "num-font-sz-large";
			if (value.rank > 99) {
				num_font_sz = "num-font-sz-small";
			}
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override margin-cont">
				<div className="w-15 position-relative">
					<div className="numBlueImgCont">
						<div className={`numImg ${num_font_sz}`}>{value.rank}</div>
					</div>
				</div>
				<div className="w-80 col-wht bg-bluver flt-lft pad-tb5-lr10">
					<div className="w-65 flt-lft top-data">
						<div className="top-title">{value.name}</div>
						<div className="top-shop">{value.company_name} | {value.shop_state}</div>
					</div>
					<div className="w-35 txt-rgt top-points top-points-2">
						<span className="top-points-val">{value.points}</span>
						<span className="top-points-img"><img src={require("./../images/pay-point-icon.svg").default} alt="point-icon" className="img-fluid"/></span>
					</div>
				</div>
			</div>;
		} else {
			num_font_sz = "num-font-sz-large";
			if (value.rank > 99) {
				num_font_sz = "num-font-sz-small";
			}
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override margin-cont">
				<div className="w-15 position-relative">
					<div className="numWhtImgCont">
						<div className={`numImg ${num_font_sz}`}>{value.rank}</div>
					</div>
				</div>
				<div className="w-80 col-bluver bg-wht flt-lft pad-tb5-lr10">
					<div className="w-65 flt-lft top-data">
						<div className="top-title">{value.name}</div>
						<div className="top-shop">{value.company_name} | {value.shop_state}</div>
					</div>
					<div className="w-35 txt-rgt top-points top-points-2">
						<span className="top-points-val">{value.points}</span>
						<span className="top-points-img"><img src={require("./../images/pay1-points-img.svg").default} alt="point-icon" className="img-fluid"/></span>
					</div>
				</div>
			</div>;
		}
		return html;
	}
    async function myTeam(type){
		if(type == localStorage.getItem("lType")) {
			console.log("hh");
			return '';
		}
        if(type === "myTeam"){
            setSwitchType({"bg_col_2":"white","color_2":"#454545","bg_col_1":"#454545","color_1":"white"});
        } else {
            setSwitchType({ "bg_col_1": "white", "color_1": "#454545", "bg_col_2": "#454545", "color_2": "white" });
        }
        localStorage.setItem("lType", type);
        if (type == 'all') {
            console.log("aa");

            getLeaderboardData();
        } else {
            console.log("bb");

            loadMore("down");
        }
    }
    return (
        <>
            {/* <HelmetProvider> */}
            <Helmet link={
                [{ "rel": "stylesheet", "href": 'css/leaderboard.css' }]
            } />
            {/* </HelmetProvider> */}
            <div className="row no-gutters">
                {error1 === false && (
                    <div className="application">
                        <div className="appHeader bg-bkb-ldr-head text-light position-sticky">
                            <div className="left h-100">
                                {/* <a className="headerButton goBack" onClick={() => history.goBack()} >
                        <img src={require("./../images/black-back.svg").default} alt="back" className="img-fluid" />
                    </a> */}
                                <img
                                    src={require("./../images/left-arrow-black.png").default}
                                    className="img-fluid backIcon"
                                    onClick={() => history.goBack()}
                                    style={{
                                        width: "22px",
                                        cursor: "pointer"
                                    }}
                                />

                            </div>
                            <img className="mt-2 mt-ldr" style={{ width: `35%` }} src={require("./../images/bkb-header.png").default} alt="alt" />
                        </div>
                        <div className='appHeader  position-sticky switch-leaderboard-outer'>
                            <span className='switch-leaderboard-inner left w-45' style={{ backgroundColor: switchType.bg_col_1, color: switchType.color_1 }} onClick={() => myTeam('all')} >
                                Global Leaderboard
                            </span>
                            <span className='switch-leaderboard-inner right w-45' style={{ backgroundColor: switchType.bg_col_2, color: switchType.color_2 }} onClick={() => myTeam('myTeam')} >
                                My Distributor Rank
                            </span>
                        </div>
                        <div className="leaderboard-section-2" id="bg-grey-3" onScroll={onScroll}>
                            {leaders}

                        </div>
                        {/*
	        <div className="section bg-grey leaderboard-section px-14" id="bg-grey-2" onScroll={onScroll}>
	            <ul className="listview image-listview leaderlist">
					{leaders}
	            </ul>
	        </div>
	    */}
                        {/*
	        <div className="section" id="fixed-footer">
	            <ul className="listview image-listview leaderlist">        
					<li>
						<a className="item">
							<span className="leader-number">{leaderData.self.rank}</span>
							<img src={leaderData.self.profile_pic} alt="image" className="image"/>
							<div className="in">
								<div className="leader">
									{leaderData.self.name}
									<footer className="leader-state">{leaderData.self.city}</footer>
								</div>
								<span className="leader-points">{leaderData.self.points}<span className="border-bottom-red"> pts</span></span>
							</div>
						</a>
					</li>
				</ul>
	        </div>
    	*/}
                    </div>
                )}
                {error1 === true && (
                    <Redirect to='/' />
                )}
                <div className="bg"></div>
            </div>
        </>
    );
}

export default RmsLeaderboard;
